module.exports = __webpack_public_path__ + "img/13.1a73e339.png";